import React, {useCallback} from 'react';

import {WidthItem} from 'src/components/width-item';
import {platformAlertTypes} from 'src/modules/platform-alert-builder/constants';

import {FlatButton} from '@pb/kit-component-button';
import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import {Group} from '@pb/kit-component-group';
import {Scroll} from '@pb/kit-component-scroll';

import {activePlatformAlertsFilterBody} from '../../active-platform-alerts.module.styl';

import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';


type Props = {
    selectedAlertTypes?: string[],
    onChange: (licenseTypes: string[]) => void,
};

export const AlertTypeFilter = ({selectedAlertTypes, onChange}: Props) => {

    const changeLicenseType = useCallback((types: ChangeTreeType) => {
        onChange(types.checkedIdsList);
    }, [onChange]);

    const selectAll = useCallback(() => {
        onChange(platformAlertTypes.map(({code}) => code));
    }, [onChange]);

    const deselectAll = useCallback(() => {
        onChange([]);
    }, [onChange]);

    return (
        <Group direction="v" alignItems="start">
            <FlatButton onClick={selectedAlertTypes?.length ? deselectAll : selectAll}>
                {selectedAlertTypes?.length ? 'Deselect All' : 'Select All'}
            </FlatButton>
            <div className={activePlatformAlertsFilterBody}>
                <Scroll>
                    <WidthItem width={270}>
                        <CheckBoxTree
                            checkedIdsList={selectedAlertTypes || []}
                            data={
                                platformAlertTypes.map(({code, description}) => ({
                                    id: code,
                                    caption: description,
                                }))
                            }
                            onChange={changeLicenseType}
                        />
                    </WidthItem>
                </Scroll>
            </div>
        </Group>
    );
};
